import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { UserService } from 'src/app/_services/user.service';
import { AuthService } from './../../_services/auth.service';

@Component({
  selector: 'app-user-show',
  templateUrl: './user-show.component.html',
  styleUrls: ['./user-show.component.css']
})
export class UserShowComponent implements OnInit {
  user:any=undefined
  constructor(
    private userService:UserService,
    private route:ActivatedRoute,
    public authService:AuthService) { }

  ngOnInit(): void {
    this.route.params.subscribe(
      x=>{
        this.userService.getById(x['userId']).subscribe({
          next:(data)=>{
            this.user=data.rs.data
          },
          error:(err)=>{
            console.error("error getById",err)
          }
        }

        )
      }
    )
  }
  lockUnlockUser(){
    this.userService.lockUnlockUser(this.user.server_user_id).subscribe({
      next:(data:ResultData)=>{
        this.user=data.rs.data
      }
    }
    )
  }
  enableDisableUser(){
    this.userService.enableDisableUser(this.user.server_user_id).subscribe({
      next:(data:ResultData)=>{
        this.user=data.rs.data
      }
    }

    )
  }

}
